import { ResolverTag } from '@ps/web-core-enums';
import type { Modal } from '@ps/web-core-store';
import { CrossPlatformLink, useResolver } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import CMSImage from '../../../../../CMSImage/CMSImage';
import type { Props } from '../../TopHeader';

import styles from './RegulatoryHeaderSE.scss';

const RegulatoryHeaderSE: React.FC<Props> = ({ regulatory_header: [{ texts, icons }] }) => {
  const depositLimitPath = useSelector(select.account.getDepositLimitPath);
  const helpResponsibleGaming = useResolver(ResolverTag.HelpResponsibleGaming);
  const helpRgRegulatorSe = useResolver(ResolverTag.HelpRGRegulatorSE);
  const helpRgSe = useResolver(ResolverTag.HelpRGSE);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const rgRegulatorSe = useResolver(ResolverTag.RGRegulatorSE);

  const { modal } = useDispatch<Dispatch>();

  const openAfterLogin = (locationParams: Modal) =>
    isAuthenticated
      ? modal.enqueue(locationParams)
      : modal.enqueue({ path: '/auth/login', locationState: locationParams });

  const openRestrictDepositLimit = () => openAfterLogin({ path: depositLimitPath });

  const openSelfExcludeFor24Hours = () => openAfterLogin({ path: '/notifications/panic-button' });

  return (
    <>
      <div className={styles.regulatoryRestriction}>
        <CrossPlatformLink href={rgRegulatorSe}>
          <CMSHTML className={styles.regulatoryText} content={texts[0].content} />
        </CrossPlatformLink>
        <CrossPlatformLink href={helpResponsibleGaming} className={styles.regulatoryIcon}>
          <CMSImage {...icons[0]} />
        </CrossPlatformLink>
      </div>
      <div className={styles.regulatoryHeader}>
        <CrossPlatformLink href={helpRgSe} className={styles.regulatoryIcon}>
          <CMSImage {...icons[1]} />
        </CrossPlatformLink>
        <CMSImage
          {...icons[2]}
          onClick={openRestrictDepositLimit}
          className={styles.regulatoryIcon}
        />
        <CrossPlatformLink href={helpRgRegulatorSe} className={styles.regulatoryIcon}>
          <CMSImage {...icons[3]} />
        </CrossPlatformLink>
        <div
          className={classNames(styles.regulatoryIcon, styles.textIcon)}
          onClick={openSelfExcludeFor24Hours}
        >
          <CMSImage {...icons[4]} />
          <CMSHTML className={styles.regulatoryText} content={texts[1].content} />
        </div>
      </div>
    </>
  );
};
export default RegulatoryHeaderSE;
